import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';

import LibraryItem from '../../containers/library-item.jsx';
import Modal from '../../containers/modal.jsx';
import Divider from '../divider/divider.jsx';
import Filter from '../filter/filter.jsx';
import TagButton from '../../containers/tag-button.jsx';
import Spinner from '../spinner/spinner.jsx';

import styles from './library.css';


import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import tabStyles from 'react-tabs/style/react-tabs.css';


const messages = defineMessages({
    filterPlaceholder: {
        id: 'gui.library.filterPlaceholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for library search field'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }
});

const ALL_TAG = {tag: 'all', intlLabel: messages.allTag};

const tagListPrefix = [ALL_TAG];

class LibraryComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleFilterChange_0',
            'handleFilterChange',
            'handleFilterClear',
            'handleFilterClear_0',
            'handleMouseEnter',
            'handleMouseEnter_0',
            'handleMouseLeave',
            'handleMouseLeave_0',
            'handleSelect',
            'handleSelect_0',
            'handleTagClick',
            'handleTagClick_0',
            'onActivateTab',
            'onActivateTab1',
            'onActivateTab2',
            'handleAddMaterialBox',
            'setFilteredDataRef'
        ]);
        this.state = {
			totalData:[],
            activePanel: 1,
            selectedItem: null,
            filterQuery: '',
            selectedTag: ALL_TAG.tag,
            loaded: false,
			
			publicTags:[ ],	
			
			selfTags:[ ],			
            selectedItem_0: null,
            filterQuery_0: '',
            selectedTag_0: 'all'
			
        };
		
    }
	
    componentDidMount () {
		
		if( this.props.dataurl ){
			fetch(this.props.dataurl, {
				method: "GET",
				headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
				}
			}).then(response => response.json())//解析为Promise
			  .then(data => {
					// 设置私有tag
					let selfTags = [{"tag":"all","intlLabel":{"id":"gui.libraryTags.xxxxxx","defaultMessage":"我喜欢的素材"}}];
					
					for(var i=0,ln=data.private.tags.length;i<ln;i++){
						var item = data.private.tags[i];
						if( item.tag ){
							selfTags.push( {"tag":item.tag,"intlLabel":{"id":"gui.libraryTags."+item.tag,"defaultMessage":item.name}} );
						}
					}
					
					let publicTags = [ ];
					
					for(var i=0,ln=data.public.tags.length;i<ln;i++){
						var item = data.public.tags[i];
						if( item.tag ){
							publicTags.push( {"tag":item.tag,"intlLabel":{"id":"gui.libraryTags."+item.tag,"defaultMessage":item.name}} );
						}
					}
					
					
					
					console.log(selfTags,"selfTags");
					console.log(publicTags,"publicTags");
					// 保存数据
					this.setState({totalData: data})  ////赋值到本地数据
					this.setState({selfTags: selfTags});
					this.setState({publicTags: publicTags});
					//this.setState({publicTags: this.props.tags});
					this.setState({loaded: true});
					
					//console.log( this.props.data ,33333333333333333333);
					//console.log( data ,444444444444444);
			});
		}else{
        // Allow the spinner to display before loading the content
			setTimeout(() => {
			   this.setState({loaded: true});
			});
		}
		
    }
    componentDidUpdate (prevProps, prevState) {
        if (prevState.filterQuery !== this.state.filterQuery ||
            prevState.selectedTag !== this.state.selectedTag) {
            this.scrollToTop();
        }
    }
    onActivateTab ( e ) {
		console.log( e );
	}
    onActivateTab1 ( ) {
		this.setState({activePanel: 1});
	}
    onActivateTab2 ( ) {
		this.setState({activePanel: 2});
	}
    handleSelect (id) {
        this.handleClose();
        this.props.onItemSelected(this.getFilteredData()[id]);
    }
	
    handleSelect_0 (id) {
        this.handleClose();
        this.props.onItemSelected(this.getSelfFilteredData()[id]);
    }
    handleClose () {
        this.props.onRequestClose();
    }
    handleAddMaterialBox (value) {
		newMaterialPackage(  );
	}
    handleTagClick (tag) {
        this.setState({
            filterQuery: '',
            selectedTag: tag.toLowerCase()
        });
    }
	
    handleTagClick_0 (tag) {
        this.setState({
            filterQuery_0: '',
            selectedTag_0: tag.toLowerCase()
        });
    }
    handleMouseEnter (id) {
        if (this.props.onItemMouseEnter) this.props.onItemMouseEnter(this.getFilteredData()[id]);
    }
    handleMouseLeave (id) {
        if (this.props.onItemMouseLeave) this.props.onItemMouseLeave(this.getFilteredData()[id]);
    }
	
    handleMouseEnter_0 (id) {
        if (this.props.onItemMouseEnter) this.props.onItemMouseEnter(this.getSelfFilteredData()[id]);
    }
    handleMouseLeave_0 (id) {
        if (this.props.onItemMouseLeave) this.props.onItemMouseLeave(this.getSelfFilteredData()[id]);
    }
    handleFilterChange_0 (event) {
        this.setState({
            filterQuery_0: event.target.value,
            selectedTag_0: ALL_TAG.tag
        });
    }
    handleFilterChange (event) {
        this.setState({
            filterQuery: event.target.value,
            selectedTag: ALL_TAG.tag
        });
    }
    handleFilterChange_0 (event) {
        this.setState({
            filterQuery_0: event.target.value,
            selectedTag_0: ALL_TAG.tag
        });
    }
    handleFilterClear () {
        this.setState({filterQuery: ''});
    }
	
    handleFilterClear_0 () {
        this.setState({filterQuery_0: ''});
    }
    getFilteredData () {
		if( this.props.dataurl ){
			var filteredData = this.state.totalData.public.materials.concat(this.props.data);
		}else{
			var filteredData = this.props.data;
		}
		
		if (this.state.selectedTag === 'all') {
			if (!this.state.filterQuery) return filteredData;
			return filteredData.filter(dataItem => (
				(dataItem.tags || [])
					// Second argument to map sets `this`
					.map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
					.concat(dataItem.name ?
						(typeof dataItem.name === 'string' ?
						// Use the name if it is a string, else use formatMessage to get the translated name
							dataItem.name : this.props.intl.formatMessage(dataItem.name.props)
						).toLowerCase() :
						null)
					.join('\n') // unlikely to partially match newlines
					.indexOf(this.state.filterQuery.toLowerCase()) !== -1
			));
		}
		return filteredData.filter(dataItem => (
			dataItem.tags &&
			dataItem.tags
				.map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
				.indexOf(this.state.selectedTag) !== -1
		));
    }
	
	getSelfFilteredData () {
		var filteredData = this.state.totalData.private.materials;
		
		if (this.state.selectedTag_0 === 'all') {
			if (!this.state.filterQuery_0) return filteredData;
			return filteredData.filter(dataItem => (
				(dataItem.tags || [])
					// Second argument to map sets `this`
					.map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
					.concat(dataItem.name ?
						(typeof dataItem.name === 'string' ?
						// Use the name if it is a string, else use formatMessage to get the translated name
							dataItem.name : this.props.intl.formatMessage(dataItem.name.props)
						).toLowerCase() :
						null)
					.join('\n') // unlikely to partially match newlines
					.indexOf(this.state.filterQuery_0.toLowerCase()) !== -1
			));
		}
		return filteredData.filter(dataItem => (
			dataItem.tags &&
			dataItem.tags
				.map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
				.indexOf(this.state.selectedTag_0) !== -1
		));
    }
	
    scrollToTop () {
        this.filteredDataRef.scrollTop = 0;
    }
    setFilteredDataRef (ref) {
        this.filteredDataRef = ref;
    }
    render () {
		
		const tabClassNames = {
			tabs: styles.tabs,
			tab: classNames(tabStyles.reactTabsTab, styles.tab),
			tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
			tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
			tabPanelSelected: classNames(tabStyles.reactTabsTabPanelSelected, styles.isSelected),
			tabSelected: classNames(tabStyles.reactTabsTabSelected, styles.isSelected)
		};
	
	
        return (
            <Modal
                fullScreen
                contentLabel={this.props.title}
                id={this.props.id}
                onRequestClose={this.handleClose}
            >
				<div className={styles.libWrapper}>
                	<div className={styles.filterBar}>
					
					<Tabs
						
						className={tabClassNames.tabs}
						selectedTabClassName={tabClassNames.tabSelected}
						selectedTabPanelClassName={tabClassNames.tabPanelSelected}
						onSelect={this.onActivateTab}
					>
						<TabList className={tabClassNames.tabList}>
							<Tab 
								className={tabClassNames.tab}
								onClick={this.onActivateTab1}
							>
								<span>我的素材包</span>
							</Tab>
							<Tab
								className={tabClassNames.tab}
								onClick={this.onActivateTab2}
							>
								<span>{this.props.libraryname}</span>
							</Tab>
						</TabList>
						<TabPanel className={tabClassNames.tabPanel}>
							<div className={styles.panelWrapper}>
							{(this.props.filterable || this.state.publicTags) && (
								<div className={styles.panelFilterBar}>
									{this.props.filterable && (
									<div className={styles.filterWrapper}>
										<Filter
											className={classNames(
												styles.filterBarItem,
												styles.filter
											)}
											filterQuery={this.state.filterQuery_0}
											inputClassName={styles.filterInput}
											placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
											onChange={this.handleFilterChange_0}
											onClear={this.handleFilterClear_0}
										/>
									</div>
									)}
								</div>
							)}
							
							
							{this.state.selfTags &&
									<div className={styles.tagWrapper}>
										{this.state.selfTags.map((tagProps, id) => (
											<TagButton
												active={this.state.selectedTag_0 === tagProps.tag.toLowerCase()} 
												iconSrc={this.state.selectedTag_0 === tagProps.tag.toLowerCase()?"//kd.stu.126.net/res/scratch/v3/static/assets/7e387914568d7ff549a39e08cb090c6a.svg":"//kd.stu.126.net/res/scratch/v3/static/assets/4306c6937ecac88f804376e3fe852f19.svg"}
												className={classNames(
													styles.filterBarItem,
													styles.tagButton,
													tagProps.className
												)}
												key={`tag-button-${id}`}
												onClick={this.handleTagClick_0}
												{...tagProps}
											/>
										))}
									</div>
							}
							
							{/*
							<div className={styles.materialPackageList}>
								<div className={styles.addMaterialDivider}>
								</div>
								<div className={styles.addMaterialBox} onClick={this.handleAddMaterialBox} >
									<img className={styles.addMaterialImg} src="//kd.stu.126.net/res/scratch/v3/static/assets/240f7da53408c2c90c99509fa5840c85.svg"/>
									<span>
										新建素材包
									</span>
								</div>}
							</div>
							*/}
							
							</div>
						</TabPanel>
						<TabPanel className={tabClassNames.tabPanel}>
							{(this.props.filterable || this.state.publicTags) && (
								<div className={styles.filterBar}>
									{this.props.filterable && (
									<div className={styles.filterWrapper}>
										<Filter
											className={classNames(
												styles.filterBarItem,
												styles.filter
											)}
											filterQuery={this.state.filterQuery}
											inputClassName={styles.filterInput}
											placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
											onChange={this.handleFilterChange}
											onClear={this.handleFilterClear}
										/>
									</div>
									)}
									
									
									{this.state.publicTags &&
										<div className={styles.tagWrapper}>
											{tagListPrefix.concat(this.state.publicTags).map((tagProps, id) => (
												<TagButton
													active={this.state.selectedTag === tagProps.tag.toLowerCase()}
													className={classNames(
														styles.filterBarItem,
														styles.tagButton,
														tagProps.className
													)}
													key={`tag-button-${id}`}
													onClick={this.handleTagClick}
													{...tagProps}
												/>
											))}
										</div>
									}
								</div>
							)}
						</TabPanel>
					</Tabs>
				
					</div>
                <div
                    className={classNames(styles.libraryScrollGrid, {
                        [styles.withFilterBar]: this.props.filterable || this.state.publicTags
                    })}
                    ref={this.setFilteredDataRef}
                >
				<div className={styles.libraryScrollGridContent}>
					{
						this.state.activePanel==1?(
						
							this.state.loaded ? this.getSelfFilteredData().map((dataItem, index) => (
							<LibraryItem
								bluetoothRequired={dataItem.bluetoothRequired}
								collaborator={dataItem.collaborator}
								description={dataItem.description}
								disabled={dataItem.disabled}
								extensionId={dataItem.extensionId}
								featured={dataItem.featured}
								hidden={dataItem.hidden}
								iconMd5={dataItem.md5}
								iconRawURL={dataItem.rawURL}
								icons={dataItem.json && dataItem.json.costumes}
								id={index}
								insetIconURL={dataItem.insetIconURL}
								internetConnectionRequired={dataItem.internetConnectionRequired}
								key={typeof dataItem.name === 'string' ? dataItem.name : dataItem.rawURL}
								name={dataItem.name}
								onMouseEnter={this.handleMouseEnter_0}
								onMouseLeave={this.handleMouseLeave_0}
								onSelect={this.handleSelect_0}
							/>
						)) : (
							<div className={styles.spinnerWrapper}>
								<Spinner
									large
									level="primary"
								/>
							</div>
						)
						
						
						):(this.state.loaded ? this.getFilteredData().map((dataItem, index) => (
                        <LibraryItem
                            bluetoothRequired={dataItem.bluetoothRequired}
                            collaborator={dataItem.collaborator}
                            description={dataItem.description}
                            disabled={dataItem.disabled}
                            extensionId={dataItem.extensionId}
                            featured={dataItem.featured}
                            hidden={dataItem.hidden}
                            iconMd5={dataItem.md5}
                            iconRawURL={dataItem.rawURL}
                            icons={dataItem.json && dataItem.json.costumes}
                            id={index}
                            insetIconURL={dataItem.insetIconURL}
                            internetConnectionRequired={dataItem.internetConnectionRequired}
                            key={typeof dataItem.name === 'string' ? dataItem.name : dataItem.rawURL}
                            name={dataItem.name}
                            onMouseEnter={this.handleMouseEnter}
                            onMouseLeave={this.handleMouseLeave}
                            onSelect={this.handleSelect}
                        />
                    )) : (
                        <div className={styles.spinnerWrapper}>
                            <Spinner
                                large
                                level="primary"
                            />
                        </div>
                    ))}
					</div>
                </div>
                </div>
            </Modal>
        );
    }
}

LibraryComponent.propTypes = {
    data: PropTypes.arrayOf(
        /* eslint-disable react/no-unused-prop-types, lines-around-comment */
        // An item in the library
        PropTypes.shape({
            // @todo remove md5/rawURL prop from library, refactor to use storage
            md5: PropTypes.string,
            name: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node
            ]),
            rawURL: PropTypes.string
        })
        /* eslint-enable react/no-unused-prop-types, lines-around-comment */
    ),
    filterable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    onItemMouseEnter: PropTypes.func,
    onItemMouseLeave: PropTypes.func,
    onItemSelected: PropTypes.func,
    onRequestClose: PropTypes.func,
    tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    title: PropTypes.string.isRequired
};

LibraryComponent.defaultProps = {
    filterable: true
};

export default injectIntl(LibraryComponent);
